import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class ExpensesProjectsService {

    // Get projects expenses list service
    getExpensesProjects = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc', projectId = '', providerId = '', yearFrom = '', yearTo = '') => {
        let url = `${API_URL}/expensesProjects?page=${pageNum}&search=${search}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`

        // Añadir providerId si existe
        if (providerId) {
            url += `&providerId=${providerId}`
        }

        // Añadir projectId si existe
        if (projectId) {
            url += `&projectId=${projectId}`
        }

        // Añadir los filtros de fecha si están presentes
        if (yearFrom) {
            url += `&yearFrom=${yearFrom}`
        }

        if (yearTo) {
            url += `&yearTo=${yearTo}`
        }

        return await axios.get(url, { headers: authHeader() })
    }

    // Add new project expense
    addExpenseProject = async (expenseProject) => {
        return await axios.post(API_URL + '/expensesProjects', expenseProject, { headers: authHeader() })
    }

    // Update project expense data
    updateExpenseProject = async (expenseProject, id) => {
        return await axios.patch(API_URL + '/expensesProjects/' + id, expenseProject, { headers: authHeader() })
    }

    // Get project expense data
    getExpenseProject = async (id) => {
        return await axios.get(API_URL + '/expensesProjects/' + id, { headers: authHeader() })
    }

    // Delete project expense
    deleteExpenseProject = async (id) => {
        return await axios.delete(API_URL + '/expensesProjects/' + id, { headers: authHeader() })
    }

    // Get expenses projects chart dataset
    getExpensesProjectsDataset = async ({ projectId = '', providerId = '', yearFrom = '', yearTo = '' }) => {
        const params = new URLSearchParams()
        if (projectId) params.append("projectId", projectId)
        if (providerId) params.append("providerId", providerId)
        if (yearFrom) params.append("yearFrom", yearFrom)
        if (yearTo) params.append("yearTo", yearTo)

        const url = `${API_URL}/dataset/expensesProjects?${params.toString()}`

        return await axios.get(url, { headers: authHeader() })
    }

}

export default new ExpensesProjectsService()